import { useEffect, useState } from "react";

import { Button } from "@blueprintjs/core";

import { Box } from "@/components/layout/flexbox";
import { ProgramQueryDocument, useUpdateProgramMutation } from "@/graphql";

let updateTimeoutRef: NodeJS.Timeout;

interface ProgramLaunchingEmailProps {
  programId: string;
  guideText?: string;
  emailSend?: boolean;
  onCompleteEmailSend?: () => void;
}

export function ProgramLaunchingEmailSection({
  programId,
  guideText = "",
  onCompleteEmailSend = () => {},
  emailSend = false,
}: ProgramLaunchingEmailProps) {
  const [loading, setLoading] = useState(false);
  const [updateProgram, { loading: updating }] = useUpdateProgramMutation({
    onCompleted: () => {
      onCompleteEmailSend();
      setLoading(false);
    },
    onError: () => {
      setLoading(false);
    },
    refetchQueries: [
      {
        query: ProgramQueryDocument,
        variables: {
          programId,
        },
      },
    ],
  });

  useEffect(() => {
    return () => clearTimeout(updateTimeoutRef);
  }, []);

  const onClickComplete = () => {
    setLoading(true);
    clearTimeout(updateTimeoutRef);
    updateTimeoutRef = setTimeout(() => {
      updateProgram({
        variables: {
          programId,
          name: null,
          targetLaunchDate: null,
          scheduleLaunchEmail: true,
        },
      });
    }, 500);
  };
  return (
    <Box>
      <Box>{guideText}</Box>
      {!emailSend && (
        <Box my={3}>
          <Button
            disabled={updating || loading}
            loading={updating || loading}
            intent="primary"
            large
            onClick={onClickComplete}
          >
            Mark as Complete
          </Button>
        </Box>
      )}
    </Box>
  );
}
